export default "__VITE_ASSET__SRlUKY8B__"